import type { PageLoad } from './$types';
import type { PageData } from '$lib/metadataTypes/MetaTypes';

export const load: PageLoad = async ({ parent }): Promise<PageData> => {
  const { site, category } = await parent(); // parent() = CategoryData

  return {
    site,
    category,
    page: {
			title: "The Freon Interpreter Framework",
description: "Learn how Freon generates and structures interpreters, how to extend evaluation functions, and how runtime objects and interpreter contexts work together to evaluate models.",
tags: [ "interpreter", "evaluation", "runtime", "context", "Freon", "DSL development", "runtime object", "meta levels", "AST"] ,
modifiedTime: "2025-11-07T17:59:27.393Z",
publishedTime: "2025-11-07T17:20:18.626Z"
    }
  };
};